import React from 'react';
import { useGlobalContext } from '../../../store/global';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';

const AlertValidation = (props) => {
  const { closeModal } = useGlobalContext();
  const { t } = useTranslation();
  const onConfirm = () => {
    closeModal();
  };

  return (
      <div className="popup-inner admin-msg" style={{ maxWidth: '650px' }}>
        <div className="popup-title">{t('note_modal_title')}</div>
        <div className="popup-content">
          <div className="popup-content--icon">
            <img src="/assets/images/info-triangle.svg" alt="alert logo" />
          </div>
          <div className="popup-content--text">
            <h1 className="popup-content--text--title">{t("update_under_validation_title")}</h1>
            <p className="popup-content--text--alert">{t("update_under_validation_content")}</p>
          </div>
        </div>
        <div className="popup-actions">
          <div
            className="popup-actions--button popup-actions--button__confirm" 
            onClick={onConfirm}>
            {t("got_it")}
          </div>
        </div>  
    </div>
  );
}

export default withRouter(AlertValidation);